// src/components/DietaryTiles.js
// The five preference tiles, shared by the full-screen mall screen and the bottom sheet.
import React from 'react';
import { DIETARY_OPTIONS } from '../utils/dietary';

export default function DietaryTiles({ value, onChange, isAr, large = false }) {
  return (
    <div style={{
      display: 'grid', gap: large ? 24 : 10, width: '100%',
      gridTemplateColumns: large ? 'repeat(3, minmax(0, 1fr))' : 'repeat(2, minmax(0, 1fr))',
    }}>
      {DIETARY_OPTIONS.map(o => {
        const selected = value === o.key;
        return (
          <button key={o.key} type="button" onClick={() => onChange(o.key)} style={{
            position: 'relative', textAlign: 'center', cursor: 'pointer',
            padding: large ? '32px 20px' : '14px 10px', borderRadius: large ? 28 : 14,
            background: 'var(--bg2)', color: 'var(--text)',
            border: `${large ? 3 : 2}px solid ${selected ? 'var(--accent)' : 'var(--border)'}`,
          }}>
            {selected && (
              <span style={{
                position: 'absolute', top: large ? 14 : 6, insetInlineEnd: large ? 16 : 8,
                width: large ? 36 : 22, height: large ? 36 : 22, borderRadius: '50%',
                background: 'var(--accent)', color: '#000', fontWeight: 800,
                fontSize: large ? 22 : 13, display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>✓</span>
            )}
            <div style={{ fontSize: large ? 64 : 30 }}>{o.icon}</div>
            <div style={{ fontSize: large ? 28 : 15, fontWeight: 800, marginTop: large ? 10 : 4 }}>{isAr ? o.ar : o.en}</div>
            <div style={{ fontSize: large ? 17 : 11, color: 'var(--text2)', marginTop: large ? 6 : 2 }}>{isAr ? o.descAr : o.descEn}</div>
          </button>
        );
      })}
    </div>
  );
}
